//* THIS FILE IS AUTO-GENERATED. DO NOT EDIT.
export default {
  ao: "अंगोला",
  aq: "अंटार्कटिका",
  az: "अज़रबैजान",
  af: "अफ़गानिस्तान",
  as: "अमेरिकी समोआ",
  aw: "अरूबा",
  ar: "अर्जेंटीना",
  sv: "अल सल्वाडोर",
  dz: "अल्जीरिया",
  al: "अल्बानिया",
  im: "आइल ऑफ़ मैन",
  is: "आइसलैंड",
  ie: "आयरलैंड",
  am: "आर्मेनिया",
  id: "इंडोनेशिया",
  ec: "इक्वाडोर",
  gq: "इक्वेटोरियल गिनी",
  il: "इज़राइल",
  it: "इटली",
  et: "इथियोपिया",
  iq: "इराक",
  er: "इरिट्रिया",
  ir: "ईरान",
  uz: "उज़्बेकिस्तान",
  kp: "उत्तर कोरिया",
  mk: "उत्तरी मकदूनिया",
  mp: "उत्तरी मारियाना द्वीपसमूह",
  uy: "उरूग्वे",
  ai: "एंग्विला",
  ag: "एंटिगुआ और बरबुडा",
  ad: "एंडोरा",
  ax: "एलैंड द्वीपसमूह",
  ee: "एस्टोनिया",
  at: "ऑस्ट्रिया",
  au: "ऑस्ट्रेलिया",
  om: "ओमान",
  kh: "कंबोडिया",
  kz: "कज़ाखस्तान",
  qa: "क़तर",
  ca: "कनाडा",
  cd: "कांगो - किंशासा",
  cg: "कांगो – ब्राज़ाविल",
  ki: "किरिबाती",
  kg: "किर्गिज़स्तान",
  ck: "कुक द्वीपसमूह",
  kw: "कुवैत",
  ke: "केन्या",
  cv: "केप वर्ड",
  cm: "कैमरून",
  ky: "कैमेन द्वीपसमूह",
  bq: "कैरिबियन नीदरलैंड",
  cc: "कोकोस (कीलिंग) द्वीपसमूह",
  ci: "कोट डी आइवर",
  km: "कोमोरोस",
  co: "कोलंबिया",
  cr: "कोस्टारिका",
  cu: "क्यूबा",
  cw: "क्यूरासाओ",
  cx: "क्रिसमस द्वीप",
  hr: "क्रोएशिया",
  gg: "गर्नसी",
  gm: "गाम्बिया",
  gn: "गिनी",
  gw: "गिनी-बिसाउ",
  gu: "गुआम",
  gy: "गुयाना",
  ga: "गैबॉन",
  gl: "ग्रीनलैंड",
  gd: "ग्रेनाडा",
  gt: "ग्वाटेमाला",
  gp: "ग्वाडेलूप",
  gh: "घाना",
  td: "चाड",
  cl: "चिली",
  cn: "चीन",
  cz: "चेकिया",
  jm: "जमैका",
  de: "जर्मनी",
  je: "जर्सी",
  jp: "जापान",
  zm: "ज़ाम्बिया",
  dj: "जिबूती",
  gi: "जिब्राल्टर",
  zw: "ज़िम्बाब्वे",
  ge: "जॉर्जिया",
  jo: "जॉर्डन",
  to: "टोंगा",
  tg: "टोगो",
  tn: "ट्यूनीशिया",
  dk: "डेनमार्क",
  do: "डोमिनिकन गणराज्य",
  dm: "डोमिनिका",
  tz: "तंज़ानिया",
  tw: "ताइवान",
  tj: "ताज़िकिस्तान",
  tl: "तिमोर-लेस्त",
  tc: "तुर्क और कैकोज़ द्वीपसमूह",
  tm: "तुर्कमेनिस्तान",
  tr: "तुर्की",
  tv: "तुवालू",
  tk: "तोकेलाउ",
  tt: "त्रिनिदाद और टोबैगो",
  th: "थाईलैंड",
  za: "दक्षिण अफ़्रीका",
  kr: "दक्षिण कोरिया",
  gs: "दक्षिण जॉर्जिया और दक्षिण सैंडविच द्वीपसमूह",
  ss: "दक्षिण सूडान",
  ne: "नाइजर",
  ng: "नाइजीरिया",
  nr: "नाउरु",
  na: "नामीबिया",
  ni: "निकारागुआ",
  nl: "नीदरलैंड",
  nu: "नीयू",
  np: "नेपाल",
  nf: "नॉरफ़ॉक द्वीप",
  no: "नॉर्वे",
  nc: "न्यू कैलेडोनिया",
  nz: "न्यूज़ीलैंड",
  pa: "पनामा",
  py: "पराग्वे",
  pw: "पलाऊ",
  eh: "पश्चिमी सहारा",
  pk: "पाकिस्तान",
  pg: "पापुआ न्यू गिनी",
  pn: "पिटकैर्न द्वीपसमूह",
  pt: "पुर्तगाल",
  pe: "पेरू",
  pr: "पोर्टो रिको",
  pl: "पोलैंड",
  fj: "फ़िजी",
  fi: "फ़िनलैंड",
  ph: "फ़िलिपींस",
  ps: "फ़िलिस्तीनी क्षेत्र",
  fo: "फ़ेरो द्वीपसमूह",
  fk: "फ़ॉकलैंड द्वीपसमूह",
  fr: "फ़्रांस",
  tf: "फ़्रांसीसी दक्षिणी क्षेत्र",
  gf: "फ़्रेंच गुयाना",
  pf: "फ़्रेंच पोलिनेशिया",
  bm: "बरमूडा",
  bh: "बहरीन",
  bs: "बहामास",
  bd: "बांग्लादेश",
  bb: "बारबाडोस",
  bi: "बुरुंडी",
  bf: "बुर्किना फ़ासो",
  bg: "बुल्गारिया",
  bj: "बेनिन",
  by: "बेलारूस",
  bz: "बेलीज़",
  be: "बेल्जियम",
  bw: "बोत्स्वाना",
  bo: "बोलीविया",
  bv: "बोवेत द्वीप",
  ba: "बोस्निया और हर्ज़ेगोविना",
  br: "ब्राज़ील",
  vg: "ब्रिटिश वर्जिन द्वीपसमूह",
  io: "ब्रिटिश हिंद महासागरीय क्षेत्र",
  bn: "ब्रूनेई",
  in: "भारत",
  bt: "भूटान",
  mn: "मंगोलिया",
  mo: "मकाऊ (विशेष प्रशासनिक क्षेत्र चीन)",
  cf: "मध्य अफ़्रीकी गणराज्य",
  mw: "मलावी",
  my: "मलेशिया",
  fm: "माइक्रोनेशिया",
  yt: "मायोते",
  mq: "मार्टीनिक",
  mh: "मार्शल द्वीपसमूह",
  mv: "मालदीव",
  ml: "माली",
  mt: "माल्टा",
  eg: "मिस्र",
  mg: "मेडागास्कर",
  mx: "मैक्सिको",
  mr: "मॉरिटानिया",
  mu: "मॉरीशस",
  md: "मॉल्डोवा",
  ms: "मोंटसेरात",
  me: "मोंटेनेग्रो",
  mz: "मोज़ांबिक",
  mc: "मोनाको",
  ma: "मोरक्को",
  mm: "म्यांमार (बर्मा)",
  ye: "यमन",
  ug: "युगांडा",
  um: "यू॰एस॰ आउटलाइंग द्वीपसमूह",
  vi: "यू॰एस॰ वर्जिन द्वीपसमूह",
  ua: "यूक्रेन",
  gb: "यूनाइटेड किंगडम",
  gr: "यूनान",
  rw: "रवांडा",
  re: "रियूनियन",
  ru: "रूस",
  ro: "रोमानिया",
  lu: "लग्ज़मबर्ग",
  lr: "लाइबेरिया",
  la: "लाओस",
  lv: "लातविया",
  li: "लिचेंस्टीन",
  lt: "लिथुआनिया",
  ly: "लीबिया",
  lb: "लेबनान",
  ls: "लेसोथो",
  vu: "वनुआतू",
  wf: "वालिस और फ़्यूचूना",
  vn: "वियतनाम",
  va: "वेटिकन सिटी",
  ve: "वेनेज़ुएला",
  lk: "श्रीलंका",
  ae: "संयुक्त अरब अमीरात",
  us: "संयुक्त राज्य",
  sa: "सऊदी अरब",
  ws: "समोआ",
  rs: "सर्बिया",
  cy: "साइप्रस",
  st: "साओ टोम और प्रिंसिपे",
  sg: "सिंगापुर",
  sx: "सिंट मार्टिन",
  sl: "सिएरा लियोन",
  sy: "सीरिया",
  sd: "सूडान",
  sr: "सूरीनाम",
  kn: "सेंट किट्स और नेविस",
  pm: "सेंट पिएरे और मिक्वेलान",
  bl: "सेंट बार्थेलेमी",
  mf: "सेंट मार्टिन",
  lc: "सेंट लूसिया",
  vc: "सेंट विंसेंट और ग्रेनाडाइंस",
  sh: "सेंट हेलेना",
  sn: "सेनेगल",
  sc: "सेशेल्स",
  sm: "सैन मेरीनो",
  so: "सोमालिया",
  sb: "सोलोमन द्वीपसमूह",
  es: "स्पेन",
  sk: "स्लोवाकिया",
  si: "स्लोवेनिया",
  sz: "स्वाज़ीलैंड",
  sj: "स्वालबार्ड और जान मायेन",
  ch: "स्विट्ज़रलैंड",
  se: "स्वीडन",
  hu: "हंगरी",
  hm: "हर्ड द्वीप और मैकडोनॉल्ड द्वीपसमूह",
  hk: "हाँग काँग (चीन विशेष प्रशासनिक क्षेत्र)",
  ht: "हैती",
  hn: "होंडूरास",
};
